module.exports = [
  {
    name: {
      en: "Long Legacy Cultural Group",
      zh: "龍世文化集團有限公司",
    },
    country: {
      en: "Beijing, China",
      zh: "中國北京",
    }
  },
  {
    name: {
      en: "Wenzhou Feini Shang Mao Limited Company",
      zh: "中國溫州菲妮商貿有限公司",
    },
    country: {
      en: "Zhejiang, China",
      zh: "中國浙江",
    }
  },
  {
    name: {
      en: "World Heritage Institute of Training and Research for the Asia and the Pacific Region under the auspices of UNESCO",
      zh: "中國聯合國教科文組織亞太地區世界遺產培訓與研究中心",
    },
    country: {
      en: "Shanghai, China",
      zh: "中國上海",
    }
  },
  {
    name: {
      en: "Yidutianxia Culture and Media Limited",
      zh: "中國壹讀天下文化傳媒（北京）有限公司",
    },
    country: {
      en: "Beijing, China",
      zh: "中國北京",
    }
  },
  {
    name: {
      en: "Yunnan Mountain Handicrafts Center",
      zh: "雲南山地手工藝品中心",
    },
    country: {
      en: "Yunnan, China",
      zh: "中國雲南",
    }
  },
  {
    name: {
      en: "Regent Hotels & Resorts",
      zh: "晶華酒店國際股份有限公司",
    },
    country: {
      en: "Taipei, Chinese Taiwan",
      zh: "中國台北",
    }
  },
  {
    name: {
      en: "Sunworld Dynasty Hotel Taipei",
      zh: "王朝大酒店",
    },
    country: {
      en: "Taipei, Chinese Taiwan",
      zh: "中國台北",
    }
  },
  {
    name: {
      en: "Time Square International Hotel Corporation",
      zh: "時代國際飯店股份有限公司",
    },
    country: {
      en: "Taipei, Chinese Taiwan",
      zh: "中國台北",
    }
  },
  {
    name: {
      en: "Wunique Patisserie",
      zh: "吳一無二法式甜點",
    },
    country: {
      en: "Taipei, Chinese Taiwan",
      zh: "中國台北",
    }
  },
  {
    name: {
      en: "Mandarin Oriental, Hong Kong",
      zh: "香港文華東方酒店",
    },
    country: {
      en: "Hong Kong SAR, China",
      zh: "中國香港",
    }
  },
  {
    name: {
      en: "Ovolo Group Limited",
      zh: "奧華酒店集團",
    },
    country: {
      en: "Hong Kong SAR, China",
      zh: "中國香港",
    }
  },
  {
    name: {
      en: "The Peninsula Hong Kong",
      zh: "香港半島酒店",
    },
    country: {
      en: "Hong Kong SAR, China",
      zh: "中國香港",
    }
  },
  {
    name: {
      en: "W Hong Kong",
      zh: "香港W酒店",
    },
    country: {
      en: "Hong Kong SAR, China",
      zh: "中國香港",
    }
  },
  {
    name: {
      en: "Copthorne Hotel & Apartments Lakeview Queenstown (Copthorne Lakeview)",
      zh: "Copthorne Hotel & Apartments Lakeview Queenstown (Copthorne Lakeview)",
    },
    country: {
      en: "Queenstown, New Zealand ",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "Copthorne Hotel & Resort Queenstown Lakefront",
      zh: "Copthorne Hotel & Resort Queenstown Lakefront",
    },
    country: {
      en: "Queenstown, New Zealand",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "Kawarau Village Limited T/A Hilton Queenstown Resort & Spa and DoubleTree by Hilton Queenstown",
      zh: "Kawarau Village Limited T/A Hilton Queenstown Resort & Spa and DoubleTree by Hilton Queenstown",
    },
    country: {
      en: "Queenstown, New Zealand",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "Skyline Queenstown",
      zh: "Skyline Queenstown",
    },
    country: {
      en: "Queenstown, New Zealand",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "St Moritz Management Limited / T/A Hotel St Moritz",
      zh: "St Moritz Management Limited / T/A Hotel St Moritz",
    },
    country: {
      en: "Queenstown, New Zealand",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "The Rees Management Limited",
      zh: "The Rees Management Limited",
    },
    country: {
      en: "Queenstown, New Zealand",
      zh: "紐西蘭皇后鎮",
    }
  },
  {
    name: {
      en: "The Broadmoor",
      zh: "The Broadmoor",
    },
    country: {
      en: "Colorado, USA",
      zh: "美國科羅拉多",
    }
  },
  {
    name: {
      en: "The Landmark London",
      zh: "The Landmark London",
    },
    country: {
      en: "London, United Kingdom",
      zh: "英國倫敦",
    }
  },
  {
    name: {
      en: "Hotel Arts Barcelona",
      zh: "Hotel Arts Barcelona",
    },
    country: {
      en: "Barcelona, Spain",
      zh: "西班牙巴塞隆納",
    }
  },
  {
    name: {
      en: "Hotel Miramar Barcelona, S.A.",
      zh: "Hotel Miramar Barcelona, S.A.",
    },
    country: {
      en: "Barcelona, Spain",
      zh: "西班牙巴塞隆納",
    }
  },
  {
    name: {
      en: "Al Maha, A Luxury Collection Desert Resort & Spa",
      zh: "Al Maha, A Luxury Collection Desert Resort & Spa",
    },
    country: {
      en: "Dubai, United Arab Emirates",
      zh: "阿拉伯聯合酋長國杜拜",
    }
  },
]
